import {Badge} from "@mantine/core";

// EmissionState five-state (FNP-533): PENDING / EMITTED / FAILED / RETRY / UNCERTAIN.
export const StatusBadge = ({status}: { status: string }) => {
    let color = 'gray';
    if (status === 'EMITTED') {
        color = 'green';
    } else if (status === 'PENDING') {
        color = 'gray';
    } else if (status === 'RETRY') {
        color = 'yellow';
    } else if (status === 'FAILED') {
        color = 'red';
    } else if (status === 'UNCERTAIN') {
        color = 'orange';
    }
    return <Badge color={color}>{status}</Badge>;
};
